import { guid } from "@buildwithflux/shared";
/**
 * This provider simply exports a single id parameter that is unique to the client for the lifecycle of the application.
 *
 * Because it is generated at injection time, it can be used to uniquely identify the browser or server session in which
 * the application was loaded.
 */
export class ClientIdProvider {
    clientId;
    constructor(clientId = guid()) {
        this.clientId = clientId;
    }
}
//# sourceMappingURL=common.js.map